import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/463c6ebc-70d0-48ef-9bcc-8214fd7b4568";
export const REGISTER_URL = "https://a.ntrk2.com/b889b7ad-bc24-470f-a0a5-22267af742c2";

export const LOGIN_URL_MAP = {
  "www-kiss39play.com": "https://a.ntrk2.com/72ea2bbe-00fb-46a0-b77f-c04953b29939",
  "kiss39ss.com": "https://a.ntrk2.com/72ea2bbe-00fb-46a0-b77f-c04953b29939",
};

export const REGISTER_URL_MAP = {
  "www-kiss39play.com": "https://a.ntrk2.com/eefdb459-d128-4fcf-be36-469b143dfc7c",
  "kiss39ss.com": "https://a.ntrk2.com/eefdb459-d128-4fcf-be36-469b143dfc7c",
};

export const FLOATING_BANNER_URL = "https://k39thai.com/cs";

export const DOWNLOAD_URL = "https://kiss39.loadprkw2a.com/download?openExternalBrowser=1&id=atfr6buyy15b07a";

export * from "./codes";
export * from "./context";
